export default {
  methods: {
    isSiteEu() {
      return ACC.config.society === "00001";
    },
    isSiteUs() {
      return ACC.config.society === "US3";
    },
    isSiteCn() {
      return ACC.config.society === "00401";
    },
    isSiteJp() {
      return ACC.config.society === "00101";
    },
    isSiteKr() {
      return ACC.config.society === "00601";
    }

  }
}



// WEBPACK FOOTER //
// ./src/global/mixins/SiteMixins.js